// extracted by mini-css-extract-plugin
export default {"Layout_basic":"Layout_Layout_basic__NihvF","Layout_external":"Layout_Layout_external__1K5pP"};